module.exports = __webpack_public_path__ + "img/employ.8cfbe8c0.png";